module.exports = __webpack_public_path__ + "img/C04TechRamShip2_ua.d8052e51.webp";